import * as React from "react";
import { ReactComponent as Logo } from "assets/img/logo.svg";
import { tokenManager } from "lib/tokenManager";

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
}

function handleReturnToLogin() {
    tokenManager.set(null);
    window.location.href = "/login";
}

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error("ErrorBoundary caught an error:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen w-full items-center justify-center bg-linear-to-br from-[#e8f4f8] to-[#d4e9f0] p-6">
                    <div className="w-full max-w-md px-8 text-center">
                        <Logo className="mx-auto mb-10 w-52" />
                        <h1 className="font-roboto mb-4 text-[28px] leading-[42px] font-bold text-black">
                            Session Expired
                        </h1>
                        <p className="font-roboto mb-8 text-base text-[#424242]">
                            Your login has expired or is no longer valid. Please sign in again to
                            continue.
                        </p>
                        <button
                            onClick={handleReturnToLogin}
                            className="h-14 w-full rounded-lg bg-brand-atlantic text-[13px] font-semibold tracking-wide text-white hover:bg-[#0B96D8] active:bg-[#097BB3]"
                        >
                            RETURN TO LOGIN
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
